export * from '@fhs/routing/src/routes/(drawer)/support/orders';
export { default } from '@fhs/routing/src/routes/(drawer)/support/orders';
